



import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import PayeeState from '@/models/Accounts/Shared/Payees/PayeeState';

@Component({ name: 'PayeeState' })
export default class extends SaascadaVue {

    @Prop({ required: true })
    status: PayeeState;

    get textColor() {
        var color: string = "grey--text";
        switch (this.status) {
            case PayeeState.Active:
                color = "success--text";
                break;
            case PayeeState.Deleted:
                color = "error--text";
                break;
            default:
                color = "grey-text";
                break;
        }
        return color;
    }

}
